var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"p-3 radius-10 bg-white"},[_c('MdtDiseaseForm',{attrs:{"loading":_vm.loading,"room":_vm.room},on:{"submit":_vm.addMdtDiseases,"onClose":_vm.onClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }